import { Form, Input } from 'antd'
import React, { useMemo } from 'react'
import { profileScreen } from '../../../../translates'
import { validateTitleRus } from '../../../../helper'
import SberIcon from '../../SberIcon'

const PassportIssuerNameFormItem = ({
  label = profileScreen.input.passportissuerName.label,
  rules = undefined,
  requiredRule = true,
  messageRule = profileScreen.input.passportissuerName.message,
  size = 'large',
  placeholder = profileScreen.input.passportissuerName.placeholder,
  showCheckIcon = false
}) => {
  const labelParam = useMemo(() => {
    return showCheckIcon
      ? <>{label}<SberIcon style={{ marginLeft: '0.5rem' }} /></>
      : label
  }, [label, showCheckIcon])

  return (
    <Form.Item
      name={['personalData', 'passport', profileScreen.input.passportissuerName.name]}
      label={labelParam}
      rules={rules ?? [{ required: requiredRule, message: messageRule, validator: validateTitleRus }]}
    >
      <Input
        size={size}
        placeholder={placeholder}
      />
    </Form.Item>
  )
}
export default PassportIssuerNameFormItem
